import { useEffect, useRef, useState } from "react";
import * as $ from "jquery";
import { TabView, TabPanel } from "primereact/tabview";
import { FileApi } from "../../services/akfenserviceslocal/api";
import axios from "axios";

function Upload() {
  const fileDataProdApi = new FileApi({
    username: "akfeninsaat-avocet",
    password: "G*W8Cc/k?zK&Pp9",
  });

  let api = fileDataProdApi;

  const [ShowSuccessMessage, setShowSuccessMessage] = useState(false);
  const [SuccessHeader, setSuccessHeader] = useState("");
  const [SuccessMessage, setSuccessMessage] = useState("");

  const [ShowErrorMessage, setShowErrorMessage] = useState(false);
  const [ErrorHeader, setErrorHeader] = useState("");
  const [ErrorMessage, setErrorMessage] = useState("");

  const [token, setToken] = useState();
  const [activeIndex, setActiveIndex] = useState(0);
  const inputNetAktifDeger = useRef(null);
  const inputPortfoy = useRef(null);
  const inputOperasyonelPerformans = useRef(null);
  const inputFiiliDolaşımOranı = useRef(null);

  useEffect(() => {
    if (inputNetAktifDeger.current) {
      $(inputNetAktifDeger.current).fileinput({
        language: "tr",
        uploadAsync: true,
        fileActionSettings: {
          showUpload: false,
          showZoom: false,
        },
        allowedFileExtensions: ["xlsx", "xls"],
        showUpload: false, // üstteki butonları gizler
        showCaption: true,
        msgPlaceholder: "Net Aktif Değer Dosyasını Seçiniz...",
      });
    }

    if (inputPortfoy.current) {
      $(inputPortfoy.current).fileinput({
        language: "tr",
        uploadAsync: true,
        fileActionSettings: {
          showUpload: false,
          showZoom: false,
        },
        allowedFileExtensions: ["xlsx", "xls"],
        showUpload: false, // üstteki butonları gizler
        showCaption: true,
        msgPlaceholder: "Portföy Dosyasını Seçiniz...",
      });
    }

    if (inputOperasyonelPerformans.current) {
      $(inputOperasyonelPerformans.current).fileinput({
        language: "tr",
        uploadAsync: true,
        fileActionSettings: {
          showUpload: false,
          showZoom: false,
        },
        allowedFileExtensions: ["xlsx", "xls"],
        showUpload: false, // üstteki butonları gizler
        showCaption: true,
        msgPlaceholder: "Operasyonel Performans Dosyasını Seçiniz...",
      });
    }

    if (inputFiiliDolaşımOranı.current) {
      $(inputFiiliDolaşımOranı.current).fileinput({
        language: "tr",
        uploadAsync: true,
        fileActionSettings: {
          showUpload: false,
          showZoom: false,
        },
        allowedFileExtensions: ["xlsx", "xls"],
        showUpload: false, // üstteki butonları gizler
        showCaption: true,
        msgPlaceholder: "Fiili Dolaşım Oranı (%) Dosyasını Seçiniz...",
      });
    }

    var key = localStorage.getItem("loginKey");

    if (key === undefined || key === "" || key === null) {
      window.location.href = "/fileuploadlogin";
    } else setToken(key);

    return () => {
      localStorage.removeItem("loginKey");
    };
  }, []);

  const initFileInput = () => {
    if (inputNetAktifDeger.current) {
      $(inputNetAktifDeger.current).fileinput("destroy"); // öncekini temizle

      $(inputNetAktifDeger.current).fileinput({
        language: "tr",
        uploadAsync: true,
        fileActionSettings: {
          showUpload: false,
          showZoom: false,
        },
        allowedFileExtensions: ["xlsx", "xls"],
        showUpload: false,
        showCaption: true,
        msgPlaceholder: "Net Aktif Değer Dosyasını Seçiniz...",
      });
    }

    if (inputPortfoy.current) {
      $(inputPortfoy.current).fileinput("destroy"); // öncekini temizle

      $(inputPortfoy.current).fileinput({
        language: "tr",
        uploadAsync: true,
        fileActionSettings: {
          showUpload: false,
          showZoom: false,
        },
        allowedFileExtensions: ["xlsx", "xls"],
        showUpload: false,
        showCaption: true,
        msgPlaceholder: "Portföy Dosyasını Seçiniz...",
      });
    }

    if (inputOperasyonelPerformans.current) {
      $(inputOperasyonelPerformans.current).fileinput("destroy"); // öncekini temizle

      $(inputOperasyonelPerformans.current).fileinput({
        language: "tr",
        uploadAsync: true,
        fileActionSettings: {
          showUpload: false,
          showZoom: false,
        },
        allowedFileExtensions: ["xlsx", "xls"],
        showUpload: false,
        showCaption: true,
        msgPlaceholder: "Operasyonel Performans Dosyasını Seçiniz...",
      });
    }

    if (inputFiiliDolaşımOranı.current) {
      $(inputFiiliDolaşımOranı.current).fileinput("destroy"); // öncekini temizle

      $(inputFiiliDolaşımOranı.current).fileinput({
        language: "tr",
        uploadAsync: true,
        fileActionSettings: {
          showUpload: false,
          showZoom: false,
        },
        allowedFileExtensions: ["xlsx", "xls"],
        showUpload: false,
        showCaption: true,
        msgPlaceholder: "Fiili Dolaşım Oranı (%) Dosyasını Seçiniz...",
      });
    }
  };

  const NavUpload = () => {
   
      var file = inputNetAktifDeger.current.files[0];
      if (file.name !== "NAVTemplate.xlsx") {
      setShowErrorMessage(true);
      setErrorHeader("Dosya aktarımı Başarısız.");
      setErrorMessage("Dosya ismini kontrol ediniz.");
    } else {
      let formData = new FormData();
      formData.append("file", file);

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url:
          "https://api.rasyonet.com/service-akfeninsaat-avocet/file/upload?fileContentType=Nav&token=" +
          token,
        data: formData,
      };

      axios
        .request(config)
        .then((response) => {
          if (response.status === 200) {
            setShowSuccessMessage(true);
            setSuccessHeader("Dosya aktarımı Başarılı.");
            setShowSuccessMessage("Sayfada güncel dataya ulaşabilirsiniz...");
          } else {
            setShowErrorMessage(true);
            setErrorHeader("Dosya aktarımı Başarısız.");
          }
        })
        .catch((error) => {
          setShowErrorMessage(true);
          setErrorHeader("Dosya aktarımı Başarısız.");
        });
    }
  };

  const PortfolioUpload = () => {
    
    var file = inputPortfoy.current.files[0];
    if (file.name !== "PortfolioTemplate.xlsx") {
      setShowErrorMessage(true);
      setErrorHeader("Dosya aktarımı Başarısız.");
      setErrorMessage("Dosya ismini kontrol ediniz.");
    } else {
      let formData = new FormData();
      formData.append("file", file);

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url:
          "https://api.rasyonet.com/service-akfeninsaat-avocet/file/upload?fileContentType=Portfolio&token=" +
          token,
        data: formData,
      };

      axios
        .request(config)
        .then((response) => {
          if (response.status === 200) {
            setShowSuccessMessage(true);
            setSuccessHeader("Dosya aktarımı Başarılı.");
            setShowSuccessMessage("Sayfada güncel dataya ulaşabilirsiniz...");
          } else {
            setShowErrorMessage(true);
            setErrorHeader("Dosya aktarımı Başarısız.");
          }
        })
        .catch((error) => {
          setShowErrorMessage(true);
          setErrorHeader("Dosya aktarımı Başarısız.");
        });
    }
  };

  const FreeFloatUpload = () => {
    
      var file = inputFiiliDolaşımOranı.current.files[0];

      if (file.name !== "FreeFloat.xlsx") {
        setShowErrorMessage(true);
        setErrorHeader("Dosya aktarımı Başarısız.");
        setErrorMessage("Dosya ismini kontrol ediniz.");
      } else {
      let formData = new FormData();
      formData.append("file", file);

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url:
          "https://api.rasyonet.com/service-akfeninsaat-avocet/file/upload?fileContentType=FreeFloat&token=" +
          token,
        data: formData,
      };

      axios
        .request(config)
        .then((response) => {
          if (response.status === 200) {
            setShowSuccessMessage(true);
            setSuccessHeader("Dosya aktarımı Başarılı.");
            setShowSuccessMessage("Sayfada güncel dataya ulaşabilirsiniz...");
          } else {
            setShowErrorMessage(true);
            setErrorHeader("Dosya aktarımı Başarısız.");
          }
        })
        .catch((error) => {
          setShowErrorMessage(true);
          setErrorHeader("Dosya aktarımı Başarısız.");
        });
    }
  };

  const PerformaceUpload = () => {
   
      var file = inputOperasyonelPerformans.current.files[0];

      if (file.name !== "OperasyonelPerformans.xlsx") {
        setShowErrorMessage(true);
        setErrorHeader("Dosya aktarımı Başarısız.");
        setErrorMessage("Dosya ismini kontrol ediniz.");
      } else {
      let formData = new FormData();
      formData.append("file", file);

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url:
          "https://api.rasyonet.com/service-akfeninsaat-avocet/file/upload?fileContentType=Performace&token=" +
          token,
        data: formData,
      };

      axios
        .request(config)
        .then((response) => {
          if (response.status === 200) {
            setShowSuccessMessage(true);
            setSuccessHeader("Dosya aktarımı Başarılı.");
            setShowSuccessMessage("Sayfada güncel dataya ulaşabilirsiniz...");
          } else {
            setShowErrorMessage(true);
            setErrorHeader("Dosya aktarımı Başarısız.");
          }
        })
        .catch((error) => {
          setShowErrorMessage(true);
          setErrorHeader("Dosya aktarımı Başarısız.");
        });
    }
    
  };

  useEffect(() => {
    initFileInput();
  }, [activeIndex]);

  return (
    <>
      <div className="file-upload">
        <div className="container" id="tabdiv">
          <div className="row">
            <div className="col-md-12">
              <div className="tabbable-panel">
                <div className="tabbable-line">
                  <TabView
                    activeIndex={activeIndex}
                    onTabChange={(e) => setActiveIndex(e.index)}
                  >
                    <TabPanel header="Fiili Dolaşım Oranı (%)">
                      <p className="m-0">
                        <input
                          ref={inputFiiliDolaşımOranı}
                          type="file"
                          className="file"
                          accept=".xls,.xlsx"
                        />
                        <button
                          className="btn btn-primary uploadbtn"
                          onClick={() => FreeFloatUpload()}
                        >
                          Yükle
                        </button>
                      </p>
                    </TabPanel>
                    <TabPanel header="Net Aktif Değer">
                      <p className="m-0">
                        <input
                          ref={inputNetAktifDeger}
                          type="file"
                          className="file"
                          accept=".xls,.xlsx"
                        />
                        <button
                          className="btn btn-primary uploadbtn"
                          onClick={() => NavUpload()}
                        >
                          Yükle
                        </button>
                      </p>
                    </TabPanel>
                    <TabPanel header="Portföy">
                      <p className="m-0">
                        <input
                          ref={inputPortfoy}
                          id="input-b1"
                          name="input-b2[]"
                          type="file"
                          className="file"
                          accept=".xls,.xlsx"
                        />
                        <button
                          className="btn btn-primary uploadbtn"
                          onClick={() => PortfolioUpload()}
                        >
                          Yükle
                        </button>
                      </p>
                    </TabPanel>
                    <TabPanel header="Operasyonel Performans">
                      <p className="m-0">
                        <input
                          ref={inputOperasyonelPerformans}
                          id="input-b1"
                          name="input-b2[]"
                          type="file"
                          className="file"
                          accept=".xls,.xlsx"
                        />
                        <button
                          className="btn btn-primary uploadbtn"
                          onClick={() => PerformaceUpload()}
                        >
                          Yükle
                        </button>
                      </p>
                    </TabPanel>
                  </TabView>
                </div>
              </div>

              {ShowSuccessMessage && (
                <div class="alert alert-success" role="alert">
                  <h4 class="alert-heading">{SuccessHeader}</h4>
                  <p>{SuccessMessage}</p>
                </div>
              )}
              {ShowErrorMessage && (
                <div class="alert alert-danger" role="alert">
                  <h4 class="alert-heading">{ErrorHeader}</h4>
                  <p>{ErrorMessage}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Upload;
